import { useTranslation } from "react-i18next";
import { CornerDownRight } from "lucide-react";
import { Button } from "components/common/Button";
import type { JumpToGroupButtonProps } from "./types";

export const JumpToGroupButton = ({
  groupName,
  onClick,
}: JumpToGroupButtonProps) => {
  const { t } = useTranslation();

  const label = t("smartSurveyor.groupInspector.goToGroup", {
    groupName,
  });

  return (
    <Button
      variant="text"
      size="sm"
      onClick={onClick}
      title={label}
      startAdornment={<CornerDownRight size={14} className="shrink-0" />}
      className="w-full bg-blue-50 hover:bg-blue-100"
    >
      <span className="min-w-0 flex-1 truncate text-left">{label}</span>
    </Button>
  );
};
